import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M640,498 L1920,498 L1920,273 L640,273 L640,498 Z M640,1063 L1920,1063 L1920,838 L640,838 L640,1063 Z M640,1628 L1920,1628 L1920,1403 L640,1403 L640,1628 Z M226.5,612 C101.408,612 0,510.592 0,385.5 C0,260.408 101.408,159 226.5,159 C351.592,159 453,260.408 453,385.5 C453,510.592 351.592,612 226.5,612 L226.5,612 Z M226.5,502 C290.841,502 343,449.841 343,385.5 C343,321.159 290.841,269 226.5,269 C162.159,269 110,321.159 110,385.5 C110,449.841 162.159,502 226.5,502 L226.5,502 Z M226.5,1750 C101.408,1750 0,1648.593 0,1523.5 C0,1398.407 101.408,1297 226.5,1297 C351.592,1297 453,1398.407 453,1523.5 C453,1648.593 351.592,1750 226.5,1750 L226.5,1750 Z M226.5,1640 C290.841,1640 343,1587.841 343,1523.5 C343,1459.159 290.841,1407 226.5,1407 C162.159,1407 110,1459.159 110,1523.5 C110,1587.841 162.159,1640 226.5,1640 L226.5,1640 Z M226.5,1177 C101.408,1177 0,1075.593 0,950.5 C0,825.407 101.408,724 226.5,724 C351.592,724 453,825.407 453,950.5 C453,1075.593 351.592,1177 226.5,1177 L226.5,1177 Z M226.5,1067 C290.841,1067 343,1014.841 343,950.5 C343,886.159 290.841,834 226.5,834 C162.159,834 110,886.159 110,950.5 C110,1014.841 162.159,1067 226.5,1067 L226.5,1067 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconBulletListCircleOutlineSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconBulletListCircleOutlineSolid, _Component);

  var _super = _createSuper(IconBulletListCircleOutlineSolid);

  function IconBulletListCircleOutlineSolid() {
    _classCallCheck(this, IconBulletListCircleOutlineSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconBulletListCircleOutlineSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconBulletListCircleOutline",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconBulletListCircleOutlineSolid.displayName = "IconBulletListCircleOutlineSolid";
  return IconBulletListCircleOutlineSolid;
}(Component);

IconBulletListCircleOutlineSolid.glyphName = 'bullet-list-circle-outline';
IconBulletListCircleOutlineSolid.variant = 'Solid';
IconBulletListCircleOutlineSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconBulletListCircleOutlineSolid;
export { IconBulletListCircleOutlineSolid };